import { render, staticRenderFns } from "./secondary-button.vue?vue&type=template&id=77bc4676&scoped=true&"
import script from "./secondary-button.js?vue&type=script&lang=js&"
export * from "./secondary-button.js?vue&type=script&lang=js&"
import style0 from "./secondary-button.scss?vue&type=style&index=0&id=77bc4676&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bc4676",
  null
  
)

export default component.exports